import { getWindowSize } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const breakpointMobile = 800;

export default function updateCards({
  widgetName,
  widgetOpts,
  wrapContainerClass,
  showMoreButton = false,
  allLink = false,
}) {
  const $widget = $(`#${widgetName}`);
  let isMobile;

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  function customCards() {
    const isCardLink = allLink || !getWindowSize(breakpointMobile);

    return saffire.widgets.cardWidget($widget, {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      link: isCardLink ? ['all'] : [],
      showDescription: true,
      moreButton: showMoreButton,
      maxItemsVisible: 4,
      itemsPerPanel: 1,
      buyNowButton: false,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createCustomCards(data.items, $widget, isCardLink);
        } else {
          $(`.${wrapContainerClass}`).remove();
        }
      },
    });
  }

  function createCustomCards(widgetData, $widget, isCardLink) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];
      const $cardItem = $(this);
      const showButton = showMoreButton && URL && !isCardLink;

      $cardItem.append(`
        <div class="card-content">
          <div class="widget-title-wrapper">
            <span class="widget-title">${Title}</span>
          </div>

          <div class="hover-content">
            ${Description ? `<span class="widget-description">${Description}</span>` : ''}
            ${showButton ? `<a href="${URL}" class="button">More</a>` : ''}
          </div>
        </div>
      `);

      if (isCardLink) {
        updateLinks($cardItem, URL, Title);
      } else if (showButton) {
        updateLinksAttributes(
          URL,
          `${Title} - Learn More`,
          $cardItem.find('.hover-content a.button'),
        );
      }

      validateContent($cardItem, URL, Description);
    });
  }

  function triggerFeature() {
    const matches = globalThis.matchMedia(`(max-width: ${breakpointMobile}px)`).matches;
    if (matches === isMobile) return;
    isMobile = matches;

    $widget.empty();
    customCards();
  }
  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}

function validateContent($item, moreLink, itemDescription) {
  if (!moreLink && !itemDescription) {
    $item.addClass('empty-card');
  } else if (!moreLink && itemDescription) {
    $item.attr('tabindex', 0);
  }
}

function updateLinks($item, moreLink, itemTitle) {
  if (moreLink) {
    updateLinksAttributes(moreLink, `${itemTitle} - Learn More`, $item);
  } else {
    $item.removeAttr('href');
  }
}
